﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260428
    This script contains functions used to build html elements dynamically
*/
'use strict';

const getUrlVars = () => {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    return vars;
}

/* public button functions */

const getSaveBtn = params => {
    const cssClass = params.cssClass ? ` ${params.cssClass}` : '';
    return getButton({
        content: `<span class="fa fa-floppy-o"></span> Save ${params.itemDesc}`,
        attrs: {
            cssClass: `btn btn-primary mTop10${cssClass}`,
            onclick: params.onclick
        }
    });
};

/* public icon functions */

const getButtonBadgeIcon = (params) => { // onclick at button level
    const cssClass = params.cssClass ? ` ${params.cssClass}` : '';
    return `<span class="fa '${params.iconDesc}${cssClass}"></span>`;
};

const getCloseIcon = (params) =>
    '<span class="fa fa-close closeIcon" onclick="' + getOnclick(params) + '"></span>';

const getDeleteIcon = params => {
    const title = params.title ?? 'Delete';
    return `<span class="fa fa-trash" title="${title}" onclick="${getOnclick(params)}"></span>`;
};

const getEditIcon = (params) => {
    const title = params.title ?? 'Edit';
    return `<span class="fa fa-pencil" title="${title}" onclick="${ getOnclick(params) }"></span>`;
};

/* used with drag and drop - no click event */

const getMoveIcon = (params = {}) => {
    const handleClass = params.handle ?? 'moveHandle';
    return `<span class="fa fa-bars ${handleClass}" title="Drag to sort"></span>`;
}
const getShoppingCartIcon = (params = {}) => {
    const title = params.title ?? 'Add To Cart';
    const cssClass = params.cssClass ? ` ${params.cssClass}` : '';
    return `<span class="fa fa-shopping-cart${cssClass}" title="${title}" onclick="${getOnclick(params)}"></span>`;
};

/* This function takes a key (which is an attribute name) and a value
    to build an attribute for an html element.  For example to set the
    id on a div the key would be "id" and the value would be "divName".

    Some attributes such as selected do not have a value - just selected
    would be included in the html tag */

const getAttr = (key, value) =>
    value !== undefined ? `${key}="${value}"` : key;

const getAttributes = (attrs) => {

    /* This function takes a javascript object of attributes for a element
        and returns the string used to build the html tag.  For example the
        following object may be passed

            { id: 'div_1', cssClass: 'hidden anotherclass', customAttributes: { elementId: 1, elementDetailId: 2}}

        and the function returns the following which will be used in an html tag.

            id='div_1", class="hidden anotherclass", data-elementId=1, data-elementDetailId=2
    */

    const arr = [];
    for (const key in attrs) {
        switch (key) {
            case "checked":
                if (attrs[key] === true) {
                    arr.push(getAttr(key, attrs[key]));
                }
                break;
            case "cssClass":
                if (attrs[key] !== undefined) {
                    arr.push(getAttr("class", attrs[key]));
                }
                break;
            case "customAttributes":
                for (const custAttrKey in attrs[key]) {
                    arr.push(getAttr(`data-${custAttrKey}`, attrs[key][custAttrKey]));
                }
            case "disabled":
                if ((attrs[key] !== undefined) && (attrs[key] === true)) {
                    arr.push(getAttr("disabled"));
                }
                break;
            default:
                if (attrs[key] !== undefined) {
                    arr.push(getAttr(key, attrs[key]));
                }
                break;
        }
    };
    return ' ' + (arr.join(' '));
}

const getOnclick = params =>
    (!params || !params.onclick)
        ? "alert('onclick is missing')"
        : params.onclick;

/* public html functions */

    /* The following functions create different html elements */
    /* the getTag function with the following parameters      */

const bindSelect = (params) => {
    const $ddl = $('#' + params.id);
    $ddl.empty();
    params.items.forEach(obj => {
        $ddl.append($('<option></option>')
            .attr('value', params.valueNm === undefined ? obj.value : obj[params.valueNm])
            .text(params.textNm === undefined ? obj.text : obj[params.textNm]));
    });
    if (params.dflt !== undefined) {
        $ddl.val(params.dflt);
    }
};


/* Many of the following functions create different html elements   *
    * by calling the getTag function with the following parameters     *
    *                                                                  *
    * attrs: an object containing appropriate element attributes       *
    * content: the actual content, or a function that will generate    *
    * the content                                                      */

const getButton = params => {
    const attrs = params.attrs ?? {};
    attrs.type ??= "button";
    return getTag({ tag: 'button', content: params.content, attrs });
};

const getDiv = (params) => getTag({ tag: 'div', content: params.content, attrs: params.attrs });

/*  This function creates one or more html divs to be injected into a page */
const getDivs = (params) =>
    params.divs
        .map(div => getDiv({ content: div.content, attrs: div.attrs }))
        .join('');

/*  This function creates an html hidden field element

    params
        id: The id of the hidden field.
        value: The value saved in the hidden field.
*/
const getHiddenFld = (params) =>
        getTag({ tag: 'input', attrs: { id: params.id, type: 'hidden', value: params.value } });

/*  This function creates one or more html hidden fields to be injected into a page

    params
        flds:  array of objects used to create hidden fields
            id: The id of the hidden field.
            value:  The value saved in the hidden field.
*/
const getHiddenFlds = (params) =>
    params.flds
        .map(fld => getHiddenFld({ id: fld.id, value: fld.value }))
        .join('');

const getLabel = (params) =>
    getTag({ tag: 'label', content: params.content, attrs: params.attrs });

const getList = (params) => {

    /*  This function creates an html list element

        params
            liArr - array of li objects { content: , attrs }
            listType - ul or ol
            attrs: a javascript object containing html element list attributes
    */

    return getTag({
        tag: (params.listType === undefined) ? 'ul' : 'ol',
        content: () =>
            params.liArr
                .map(li => getTag({ tag: 'li', content: li.content, attrs: li.attrs }))
                .join(''),
        attrs: params.attrs
    });
};

const getSelect = params => {
    /*
        This function creates an html select element.

        params
        items - array of objects for select list
        textNm - name of property containing displayed text - defaults to text
        valueNm - name of property containing value - defaults to Value
        fnAddItem - Function to create select list item
        prompt - (i.e. Select) as first entry - value will be 0
        dflt - selected value
        labelContent - content or function to create content for label
        labelAttrs - javascript object containing label attributes
        ctrlAttrs - javascript object containing control attributes
    */
    const bHasLabel = params.labelContent !== undefined;
    if (bHasLabel) {
        params.labelAttrs = params.labelAttrs ?? {};
        if (!Object.prototype.hasOwnProperty.call(params.labelAttrs, 'for')) {
            params.labelAttrs.for = params.ctrlAttrs.id;
        }
    }

    const lbl = bHasLabel ? getLabel({ content: params.labelContent, attrs: params.labelAttrs }) : '';

    const textNm = params.textNm ?? 'text';
    const valueNm = params.valueNm ?? 'value';

    let content = '';
    if (params.prompt !== undefined) {
        content += getSelectListItem({ content: params.prompt, attrs: { value: '0' } });
    }
    for (const item of params.items) {
        if (params.fnAddItem !== undefined) {
            content += params.fnAddItem(item, params.dflt);
        } else {
            if (params.dflt !== undefined && item[valueNm] === params.dflt) {
                content += getSelectListItem({
                    content: item[textNm],
                    attrs: { value: item[valueNm], selected: true }
                });
            } else {
                content += getSelectListItem({
                    content: item[textNm],
                    attrs: { value: item[valueNm] }
                });
            }
        }
    }
    return lbl + getTag({
        tag: 'select',
        content,
        attrs: params.ctrlAttrs
    });
};

const getSelectListItem = (params) =>
    getTag({ tag: 'option', content: params.content, attrs: params.attrs }); 

const getSpan = (params) => 
    getTag({ tag: 'span', content: params.content, attrs: params.attrs });

const getTableRows = (params) => {

    /* This function builds the rows of a table by iterating through an arr of data and
        calling a function to build each individual row
        
        arr:            Array of data
        fnGetRow:       Function to build table row
        fnNoDataRow:    Function to build no data table row 
        gridNm:         Name of table,
        fnPredicate:    Filter function

    */

    const arr = (params.fnPredicate === undefined)
        ? params.arr
        : params.arr.filter(item => params.fnPredicate(item));

    const content = (arr.length === 0 && params.fnNoDataRow !== undefined)
        ? params.fnNoDataRow()
        : arr.map(item => params.fnGetRow({ data: item })).join('');

    //$(`#${ params.gridNm } tbody`).empty().append(content);
    $(`#${ params.gridNm } tbody`).html(content);
};

const getTag = params => {
    /*
        This function builds an html element 
        
        params 
            tag:  a string defined element to be built. ie input, select, span
            attrs: a javascript object containing the attributes for the html element being built
                    ie { id: 'div1', cssClass: 'hidden' }
            content: the actual content that will be displayed for the element or a function 
                        that will generate the content.
    */

    if (params.attrs) {
        if (params.attrs.id && !params.attrs.name) {
            params.attrs.name = params.attrs.id;
        }
    }
    const attrsStr = params.attrs
        ? typeof params.attrs === 'function'
            ? getAttributes(params.attrs())
            : getAttributes(params.attrs)
        : '';
    let content = `<${params.tag}${attrsStr}>`;
    if (params.content !== undefined) {
        content += typeof params.content === 'function' ? params.content() : params.content;
    }
    return `${content}</${params.tag}>`;
};

const getTextArea = params => {
    /*
        This function creates an html text area element

        params
            labelContent - content or function to create content for label
            labelAttrs - javascript object containing label attributes
            ctrlContent - content or function to create content for textarea control
            ctrlAttrs - javascript object containing control attributes   
    */
    const ctrlContent = params.ctrlContent ?? '';
    const label = params.labelContent !== undefined
        ? getTag({ tag: 'label', content: params.labelContent, attrs: params.labelAttrs })
        : '';
    return label + getTag({ tag: 'textarea', content: ctrlContent, attrs: params.ctrlAttrs });
};

const getTextBox = params => {
    /*
        This function creates an html textbox element

        params
            labelContent - content or function to create content for label
            labelAttrs - javascript object containing label attributes
            ctrlAttrs - javascript object containing control attributes   
    */
    params.ctrlAttrs.type ??= "text";
    const label = params.labelContent !== undefined
        ? getTag({ tag: 'label', content: params.labelContent, attrs: params.labelAttrs })
        : '';
    return label + getTag({ tag: 'input', attrs: params.ctrlAttrs });
};

const getUrlParam = (params) => {
    let urlparameter = params.dflt;
    if (window.location.href.indexOf(params.key) > -1) {
        urlparameter = getUrlVars()[params.key];
    }
    return urlparameter;
};

export {
    getSaveBtn, getButtonBadgeIcon, getCloseIcon,
    getDeleteIcon, getEditIcon, getMoveIcon, getShoppingCartIcon,
    bindSelect, getButton, getDiv, getDivs, getHiddenFld, getHiddenFlds,
    getLabel, getList, getSelect, getSelectListItem, getSpan,
    getTableRows, getTag, getTextArea, getTextBox, getUrlParam
};
